import PanelesBase from "../components/paneles/PanelesBase";
import PanelesCharacteristics from "../components/paneles/PanelesCharacteristics";
import '../App.css';
import PanelesContactUs from "../components/paneles/PanelesContactUs";
import Footer from "../components/Footer";

export default function PanelesSolaresAdvise(props){
    return(
        <>
            <PanelesBase isLargeScreen={props.isLargeScreen}/>
            <div className='information-section'>
                <PanelesCharacteristics isLargeScreen={props.isLargeScreen}/>
                <PanelesContactUs isLargeScreen={props.isLargeScreen}/>    
                <Footer isService={true}/>     
            </div>     
        </>
    )
}